/*
 * COPYRIGHT:     Copyright © 2020 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

export const checkUnit = (acc, value) => ({ ...acc, [value.id]: value.actualStatus })
export const isStatusEqual = status => unit => unit.actualStatus === status
